import { useMutation, useQueryClient } from '@tanstack/react-query';
import { transportLayersEndpoints } from '@ooh/contracts';
import type { TransportLayerImportTriggerResponse } from '@ooh/contracts';
import type { WithCallWithAuth } from './queries';
import { transportLayerQueries } from './queries';

// ─── Trigger transport layer import ───────────────────────────────────────────

export function useTriggerTransportImport(auth?: WithCallWithAuth) {
  const queryClient = useQueryClient();

  return useMutation<TransportLayerImportTriggerResponse, Error, void>({
    mutationFn: () => {
      if (!auth) {
        return Promise.reject(new Error('No auth provided'));
      }
      return auth.callWithAuth(transportLayersEndpoints.triggerImport, {});
    },
    onSuccess: () => {
      if (!auth) return;
      void queryClient.invalidateQueries({
        queryKey: transportLayerQueries.importStatus(auth).queryKey,
      });
    },
  });
}
